/* eslint-disable @typescript-eslint/no-empty-function */
import { DashboardCard, Flex, P } from 'styling/GlobalStyles'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IWidget } from 'types/dashboard.interface'
import { BodyText, TitleText } from 'styling/Typography'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { HrDashboardInnerWidgetContainer, HrDashboardTitleLine } from '../HrDashboard.styled'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { CircleChart } from 'components/Chart/CircleChart'

export const HrAccommodationWidget = ({
    modalOpen,
    removeWidget,
    onDragOver,
    onDragStart,
    onDragDrop
}: IWidget) => {

    const { accommodationSummary } = useSelector((state: RootState) => state.hrDashboard)

    const percentage = (((accommodationSummary?.occupied || 0) / (accommodationSummary?.totalCapacity) || 0) * 100)

    return (
        <DashboardCard
            draggable={modalOpen}
            onDragStartCapture={() => {
                onDragStart('accommodation', 1)
            }}
            onDrop={onDragDrop}
            onDragEnd={(e) => {
                e.preventDefault()
            }}
            onDragOver={(e) => {
                e.preventDefault()
                onDragOver('accommodation')
            }}
            width='1fr'
            style={{ gridArea: 'accommodation', cursor: modalOpen ? 'grab' : 'normal' }}
        >
            {modalOpen && (
                <WidgetEditOverlay
                    onClick={(e) => {
                        removeWidget('accommodation')
                        e.stopPropagation()
                    }}
                >
                    <P>Remove Widget</P>
                    <CloseIcon white />
                </WidgetEditOverlay>
            )}
            <TitleText weight='bold'>ACCOMMODATION</TitleText>
            <HrDashboardInnerWidgetContainer style={{ height: '100%' }} >
                <Flex width='100%' column between height='100%' gap='1rem' >
                    <Flex width='100%' justcenter center column gap='1rem' >
                        <CircleChart label={percentage.toFixed(1)} percentage={percentage} />
                        <BodyText>Total capacity occupation</BodyText>
                    </Flex>
                    <Flex width='100%' gap='13px' column >
                        <HrDashboardTitleLine smallPaddingBottom>
                            <BodyText>
                                Total Capacity
                            </BodyText>
                            <TitleText weight='bold' color='#E74C3C'>
                                {accommodationSummary?.totalCapacity || '0'}
                            </TitleText>
                        </HrDashboardTitleLine>
                        <HrDashboardTitleLine smallPaddingBottom>
                            <BodyText>
                                Occupied
                            </BodyText>
                            <TitleText weight='bold' color='#E74C3C'>
                                {accommodationSummary?.occupied || '0'}
                            </TitleText>
                        </HrDashboardTitleLine>
                        <HrDashboardTitleLine smallPaddingBottom>
                            <BodyText>
                                Available
                            </BodyText>
                            <TitleText weight='bold' color='#E74C3C'>
                                {accommodationSummary?.available || '0'}
                            </TitleText>
                        </HrDashboardTitleLine>

                    </Flex>
                </Flex>


            </HrDashboardInnerWidgetContainer>

        </DashboardCard>
    )
}
